import type { ComponentProps, ElementType, FC } from 'react';
import { css, useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import IcLoadingBold from 'src/assets/images/icLoadingBold.svg';
import GenericButton from 'src/components/GenericButton';
import { rotation } from 'src/styles/animation';
type ContainerProps<E extends ElementType> = {
  as?: E;
} & ComponentProps<E>;
export const Container = <E extends ElementType,>({
  as: Component = 'div',
  ...props
}: ContainerProps<E>) => {
  const theme = useTheme();
  return <Component css={css`
        flex: 1;

        min-height: 0;

        box-sizing: border-box;
        padding: 16px 0;

        display: flex;
        flex-direction: column;
        gap: 16px;

        ${theme.screenSize.desktop} {
          width: 452px;
          gap: 32px;
        }
      `} {...props} data-sentry-element="Component" data-sentry-component="Container" data-sentry-source-file="styles.tsx" />;
};
export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--gap, 16px);

  ${({
  theme
}) => theme.screenSize.desktop} {
    gap: var(--gap, 24px);
  }
`;
export const Title = styled.h1`
  margin: 0;

  color: ${({
  theme
}) => theme.color.contentDeep};

  font-size: 40px;
  font-weight: 900;

  ${({
  theme
}) => theme.screenSize.desktop} {
    font-size: 30px;
    font-weight: 700;
  }
`;
export const NoticeText = styled.p`
  color: ${({
  theme
}) => theme.color.content10};

  font-size: 16px;
  font-weight: 400;

  ${({
  theme
}) => theme.screenSize.desktop} {
    color: ${({
  theme
}) => theme.color.content9};
    font-size: 14px;
  }
`;
export const WarningText = styled.p`
  color: ${({
  theme
}) => theme.color.content9};

  font-size: 13px;
  font-weight: 400;

  ${({
  theme
}) => theme.screenSize.desktop} {
    font-size: 10px;
  }
`;
export const LoadingIndicator = styled(IcLoadingBold)`
  animation: ${rotation} 1s ease-in-out infinite;
`;
export const NextButton = styled<FC<Omit<ComponentProps<typeof GenericButton>, 'size' | 'variant'>>>(({
  ...props
}) => <GenericButton size='large' variant='primary' {...props} />)``;